module.exports = __webpack_public_path__ + "img/2.857235d2.jpeg";